import React, { useRef, useEffect } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  loginUserLogic,
  resetLoadingState,
} from "../../../store/features/app/appSlice";
import { formDataHelper } from "../../../util/helpers";
import "./Login.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import LoginImage from "../../../assets/images/login-image.png";
import AdultLogoDark from "../../../assets/images/rosesvglogo.svg";
import YouthLogoDark from "../../../assets/images/youth_logo_dark.png";
import eyeopen from "../../../assets/icons/eye-open.svg";
import eyeclose from "../../../assets/icons/EyeClose.svg";
import { Helmet } from "react-helmet";

const Login = (props) => {
  const navigate = useNavigate();
  const passwordField = useRef();
  const passwordIcon = useRef();
  const dispatch = useDispatch();
  const { loading, user } = useSelector((state) => state.app);

  useEffect(() => {
    //*Throw the user to post-login screen if user state is not null.
    if (user) {
      if (user?.role === "INVOICING_ADMIN") {
        navigate("/billing/");
      } else if (user?.role === "CAREGIVER") {
        navigate("/caregiver/");
      } else {
        navigate("/dashboard/");
      }
    } else if (user === null && loading) {
      //* Sometimes the loading state would be stuck at true even after logout causing the Login button to be stuck at a disabled state.
      //* Calling this will reset the loading state so user can login.
      dispatch(resetLoadingState());
    }
  }, [user]);

  const toggleVisibility = () => {
    if (passwordField.current.type === "password") {
      passwordField.current.type = "text";
      passwordIcon.current.src = eyeclose;
    } else {
      passwordField.current.type = "password";
      passwordIcon.current.src = eyeopen;
    }
  };

  const handleSubmit = (form) => {
    form.preventDefault();
    let formData = new FormData(form.target);
    const data = formDataHelper(formData);

    dispatch(loginUserLogic(data));
  };
  return (
    <section className="container-fluid loginBG">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Welcome to Rose Health</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div
        className="col-sm-12 col-lg-10 col-md-10"
        style={{ margin: "0 auto" }}
      >
        <div className="row p-5">
          <div className="col-sm-12 col-lg-6 col-md-6">
            <div className="container text-center">
              <img
                src={LoginImage}
                alt="Welcome to Rose Health"
                className="img-fluid"
                style={{ height: "90vh" }}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-6 col-md-6">
            <CardLayout
              className="container col-sm-12 col-md-8 col-lg-8"
              style={{ marginTop: "5%" }}
            >
              <div className="text-center container-fluid py-3">
                <img
                  className={
                    process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                      ? "pt-3"
                      : ""
                  }
                  src={
                    process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                      ? AdultLogoDark
                      : YouthLogoDark
                  }
                  height="45%"
                  width="45%"
                  alt="Rose Health"
                />
                <div className="container pt-5">
                  <h4 className="primary-text">Welcome Again!</h4>
                  <span className="secondary-text">
                    Sign in to your Rose Account
                  </span>
                </div>
              </div>
              <form className="container" onSubmit={handleSubmit}>
                <div className="form-group pb-5">
                  <label>
                    {" "}
                    <strong>Email Address</strong>
                  </label>
                  <input
                    autoFocus
                    name="username"
                    id="username"
                    placeholder="Enter Email Address"
                  />
                </div>

                <div className="form-group pb-3">
                  <label>
                    {" "}
                    <strong>Your Password</strong>
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Enter Your Password"
                      ref={passwordField}
                    />
                    <img
                      src={eyeopen}
                      ref={passwordIcon}
                      onClick={toggleVisibility}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                      alt="Show Password"
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
                <div className="container-fluid d-flex justify-content-end">
                  <Link to="/reset">Forgot Password</Link>
                </div>
                <br />
                <div className="container-fluid text-center py-4">
                  <button
                    type="submit"
                    disabled={loading}
                    className="primary-btn"
                    style={{ width: "100%" }}
                  >
                    Login
                  </button>
                </div>
                <div className="container-fluid text-center py-3">
                  <span>Don't have a Rose account yet?</span>
                  <br />
                  <span>
                    <Link
                      to="https://rosehealth.com/schedule.html"
                      target="_blank"
                      rel="noopener noreferer"
                    >
                      Schedule a demo
                    </Link>{" "}
                    to get started
                  </span>
                </div>
              </form>
            </CardLayout>
          </div>
        </div>
      </div>
      <Outlet />
    </section>
  );
};

export default Login;
